import namespace from '../namespace';

export default [...namespace, 'routePlannerPage'];
